import { CheckCircleFilled, CloseCircleOutlined, WarningFilled } from '@ant-design/icons';
import { Flex, Tooltip } from 'antd';
import { ReactNode } from 'react';
import { EnumVerifyPayeeMatch } from 'src/api';
import { i18, trb } from 'src/Utilities';

interface IProps {
  VopResponseType: EnumVerifyPayeeMatch;
  ReceiverName: ReactNode;
  MatchedName?: string;
  translationPrefix?: string;
}

export const PayeeVerificationStatus = ({ VopResponseType, ReceiverName, MatchedName, translationPrefix = '' }: IProps) => {
  const translationKey = `${translationPrefix}${VopResponseType}`; // has to be added to src\Utilities\translationsObj.ts

  const tooltipTitle = trb(i18.PaymentBulk[translationKey as keyof typeof i18.PaymentBulk], {
    value: MatchedName,
  });

  return (
    <Flex
      gap={6}
      align="center"
    >
      {ReceiverName}
      <Tooltip title={<span dangerouslySetInnerHTML={{ __html: tooltipTitle }} />}>
        <span className="d-flex">
          {VopResponseType === EnumVerifyPayeeMatch.MTCH && <CheckCircleFilled className="text-primary" />}
          {(VopResponseType === EnumVerifyPayeeMatch.NMTC || VopResponseType === EnumVerifyPayeeMatch.NOAP || VopResponseType === EnumVerifyPayeeMatch.NOAP_OPT) && (
            <CloseCircleOutlined className="text-danger" />
          )}
          {VopResponseType === EnumVerifyPayeeMatch.CMTC && <WarningFilled className="text-orange" />}
        </span>
      </Tooltip>
    </Flex>
  );
};
